import React from 'react';
import './Loader.scss';

const Loader = ({textLoading}) => (
    <div className="wrapper-loader">
        {textLoading && <div className='text-loader'>{textLoading}</div>}
        <span className="loader"><span className="loader-inner"></span></span>
    </div>
);

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Common/Loader/Loader.js